import { render, staticRenderFns } from "./newParty.vue?vue&type=template&id=94561bc0&scoped=true&"
import script from "./newParty.vue?vue&type=script&lang=js&"
export * from "./newParty.vue?vue&type=script&lang=js&"
import style0 from "./newParty.vue?vue&type=style&index=0&id=94561bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94561bc0",
  null
  
)

export default component.exports